// components/Header.jsx
import React from 'react';

const Header = ({ restaurantName, cartItemsCount = 0, onCartClick }) => {
    return (
        <header className="sticky top-0 z-20 bg-white shadow-md backdrop-blur-sm bg-opacity-95">
            <div className="flex items-center justify-between px-4 py-3 max-w-3xl mx-auto">
                <div className="flex items-center space-x-2">
                    <div className="w-12 h-12 rounded-full overflow-hidden bg-black flex items-center justify-center shadow-inner border-2 border-amber-600">
                        <img
                            src="/logo.png"
                            alt="Addis Taim Logo"
                            className="w-full h-full object-contain"
                            onError={(e) => {
                                e.target.onerror = null;
                                // Fallback SVG if logo.png is not found
                                e.target.outerHTML = '<svg class="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>';
                            }}
                        />
                    </div>
                    <h1 className="text-xl font-bold text-gray-800 tracking-tight">
                        {restaurantName}
                    </h1>
                </div>

                <div className="flex items-center space-x-3">
                    <button aria-label="Search" className="relative p-2 text-gray-500 hover:text-amber-600 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 rounded-full">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                    </button>
                    <button
                        onClick={onCartClick}
                        aria-label="View Cart"
                        className="relative p-2 text-gray-500 hover:text-amber-600 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 rounded-full group"
                    >
                        <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                        </svg>
                        {cartItemsCount > 0 && (
                            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] font-bold leading-none text-white transform translate-x-1 -translate-y-1 bg-red-500 rounded-full shadow border-2 border-white">
                                {cartItemsCount > 99 ? '99+' : cartItemsCount}
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;